import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import store from "../vuex/store";
import {
  DimensionsConfigurationDTO,
  WineDimensionType
} from "@/model/data.model";

export default class WineService {
  getPackageTypes() {
    const request = {
      url: store.getters.BASE_API_URL + "/wine/configuration/package-type",
      method: "GET"
    } as AxiosRequestConfig;

    return axios
      .request(request)
      .then((res: AxiosResponse) => {
        return res.data;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  getConfigurationDimension(
    wineProductType: WineDimensionType,
    winePackageType: string,
    bottles?: number,
    magnums?: number
  ) {
    const request = {
      url: store.getters.BASE_API_URL + "/wine/configuration/dimension",
      params: {
        winePackageType,
        wineProductType,
        bottles,
        magnums
      },
      method: "GET"
    } as AxiosRequestConfig;

    return axios
      .request(request)
      .then((res: AxiosResponse) => {
        return res.data as DimensionsConfigurationDTO | null;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }
}
